import { TFunction } from "i18next";
import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

export const getCreateUserFormSchema = (t: TFunction) =>
  z.object({
    name: z
      .string()
      .min(1, { message: t("admin.users.errors.name-required") }),

    email: z
      .string()
      .email({ message: t("admin.users.errors.invalid-email") }),

    password: z
      .string()
      .min(3, { message: t("admin.users.errors.password-min") }),

    roleId: z
      .number({ required_error: t("admin.users.errors.role-required") })
      .min(1, { message: t("admin.users.errors.role-required") })
      .max(3, { message: t("admin.users.errors.invalid-role") }),

    phoneNumber: z
      .string()
      .nullable()
      .transform(val => val === "" ? null : val)
      .refine(val => val === null || isValidPhoneNumber(val, "PT"), { message: t("admin.accounts.errors.invalid-phone") }),
  });

export type CreateUserForm = z.infer<ReturnType<typeof getCreateUserFormSchema>>;
